import { Box, Grid, Typography } from "@material-ui/core";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import {
  getRevenueAction,
  getRevenueBarChart,
} from "src/app-redux/hq-dashboard/actions/hqDashboardActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { IDashboard, IDashboardRevenueBar } from "src/common/typings/hq-dashboard";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { useStyles } from "./style";
import {
  selectedBorderTerminals,
  selectedEndDate,
  selectedStartDate,
} from "src/app-redux/hq-dashboard/hqDashboardSlice";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

interface Props {}

export function Revenue({}: Props): React.ReactElement {
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const [showNoDataFound, setShowNoDataFound] = useState<boolean>(false);
  const [showNoBarDataFound, setShowNoBarDataFound] = useState<boolean>(true);
  const [showDetailsBox, setShowDetailsBox] = useState<boolean>(false);
  const [isOpenDailog, setIsOpenDailog] = useState(false);

  const [pieChartList, setpieChartList] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [barChartList, setbarChartList] = useState<any>([]);

  const pieChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const [data, setData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: [],
        borderWidth: 0,
      },
    ],
  });
  const [colors, setColors] = useState<any>([]);
  const [barChartData, setBarChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Vehicles",
        data: [],
        backgroundColor: "#FFD500",
        borderRadius: 50,
        barThickness: 10,
      },
    ],
  });
  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
  };
  const [barChartHeading, setBarChartHeading] = useState<string>("");
  const [barChartHeadingValue, setBarChartHeadingValue] = useState<number>(0);
  const selectedTerminals = useAppSelector(selectedBorderTerminals);
  const startDate = useAppSelector(selectedStartDate);
  const endDate = useAppSelector(selectedEndDate);
  const [selectedRevenue, setSelectedRevenue] = useState<string>("");

  useEffect(() => {
    setShowDetailsBox(false);
    setShowNoBarDataFound(true);
    if (startDate && endDate && selectedTerminals.length > 0) {
      setShowNoDataFound(false);
      getInsight(startDate, endDate);
    } else {
      setShowNoDataFound(true);
    }
  }, [startDate, endDate, selectedTerminals]);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  const getInsight = async (startDate: string, endDate: string) => {
    const colors: any = [];
    const req: IDashboard = {
      startDate: startDate,
      endDate: endDate,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getRevenueAction(req));

    if (res?.payload) {
      if (res.payload?.revenueInsightWidget.length) {
        setShowNoDataFound(false);
        setTotalAmount(
          res.payload.revenueInsightWidget.reduce(
            (partialSum: any, a: any) => partialSum + a.amount,
            0
          )
        );
        setData({
          labels: res.payload.revenueInsightWidget.map((item: any) => {
            return item.name;
          }),
          datasets: [
            {
              label: "",
              data: res.payload.revenueInsightWidget.map((item: any) => {
                return item.amount;
              }),
              backgroundColor: res.payload.revenueInsightWidget.map(() => {
                const colorCode = getNewColorCode();
                colors.push(colorCode);
                return colorCode;
              }),
              borderWidth: 0,
            },
          ],
        });
        setpieChartList(res.payload.revenueInsightWidget);
        setColors(colors);
        showRevenue(res.payload.revenueInsightWidget[0]);
      } else {
        setShowNoDataFound(true);
        setTotalAmount(0);
        setData({
          labels: [],
          datasets: [
            {
              label: "",
              data: [],
              backgroundColor: [],
              borderWidth: 0,
            },
          ],
        });
        setpieChartList([]);
        setColors([]);
      }
    }
  };

  const showRevenue = async (revenueItem: any) => {
    setSelectedRevenue(revenueItem.name);
    const req: IDashboardRevenueBar = {
      startDate: startDate,
      endDate: endDate,
      consignmentType: revenueItem.name,
      terminalId: selectedTerminals.toString(),
    };
    const res = await dispatch(getRevenueBarChart(req));
    setShowDetailsBox(true);
    if (res?.payload) {
      if (res.payload.revenueByConsignmentInsightWidget.length) {
        setShowNoBarDataFound(false);
        setbarChartList(res.payload.revenueByConsignmentInsightWidget);
        setBarChartData({
          labels: res.payload.revenueByConsignmentInsightWidget.map((item: any) => {
            return item.name;
          }),

          datasets: [
            {
              label: "PKR",
              data: res.payload.revenueByConsignmentInsightWidget.map((item: any) => {
                return item.amount;
              }),
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading(revenueItem.name);
        setBarChartHeadingValue(revenueItem.amount);
      } else {
        setShowNoBarDataFound(true);
        setBarChartData({
          labels: [],
          datasets: [
            {
              label: "Vehicles",
              data: [],
              backgroundColor: "#FFD500",
              borderRadius: 50,
              barThickness: 10,
            },
          ],
        });
        setBarChartHeading("");
        setBarChartHeadingValue(0);
      }
    }
  };

  const toggleDialog = () => {
    setIsOpenDailog(!isOpenDailog);
  };

  const rows = [
    {
      terminalId: 1,
      terminalName: "TORKHAM",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
    {
      terminalId: 2,
      terminalName: "GHULAM KHAN",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
    {
      terminalId: 3,
      terminalName: "KHARLACHI",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
    {
      terminalId: 4,
      terminalName: "CHAMAN",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
    {
      terminalId: 5,
      terminalName: "TAFTAN",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
    {
      terminalId: 6,
      terminalName: "WAHGA",
      export: "290",
      import: "187",
      att: "77",
      empty: "98",
      total: "652",
    },
  ];

  return (
    <>
      <TransitionDialog
        isOpen={isOpenDailog}
        handleClose={toggleDialog}
        maxWidth="md"
        heading="Comparison"
        isCustomValidate={true}
      >
        <table className={classes.blueTable}>
          <thead className={classes.tHead}>
            <tr>
              <th className={`${classes.tableCells} ${classes.tHead}`}>BT</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>EXPORT</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>IMPORT</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>ATT</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>EMPTY</th>
              <th className={`${classes.tableCells} ${classes.tHead}`}>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, index) => {
              return (
                <tr key={item.terminalId} className={index % 2 != 0 ? classes.nthChild : ""}>
                  <td className={`${classes.tableCells} ${classes.bodytd} ${classes.bodytdBT}`}>
                    {item.terminalName}
                  </td>
                  <td className={`${classes.tableCells} ${classes.bodytd}`}>{item.export}</td>
                  <td className={`${classes.tableCells} ${classes.bodytd}`}>{item.import}</td>
                  <td className={`${classes.tableCells} ${classes.bodytd}`}>{item.att}</td>
                  <td className={`${classes.tableCells} ${classes.bodytd}`}>{item.empty}</td>
                  <td className={`${classes.tableCells} ${classes.bodytd}`}>{item.total}</td>
                </tr>
              );
            })}
            <tr>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>TOTAL</td>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>515</td>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>550</td>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>262</td>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>773</td>
              <td className={`${classes.tableCells} ${classes.bodytd}`}>2100</td>
            </tr>
          </tbody>
        </table>
      </TransitionDialog>
      {/* Revenue Section */}
      <Grid
        item
        xs={12}
        className={classes.outer}
        style={{
          display: showNoDataFound ? "flex" : "none",
          justifyContent: "space-around",
          fontSize: "14px",
        }}
      >
        No records found.
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        style={{ display: showNoDataFound ? "none" : "flex" }}
      >
        {/* Total Revenue */}
        <Grid item xs={12} lg={showDetailsBox ? 7 : 12} className={classes.outer}>
          {/* Header */}
          <Grid item xs={12} md={7}>
            {/* Total Amount */}
            <Grid item xs={12} md={7} container direction="row">
              <Typography className={classes.headingText}>Revenue: </Typography>
              <Typography className={classes.unit}>PKR</Typography>
              <Typography className={classes.headingAmount}>
                {Math.abs(Number(totalAmount)) >= 1.0e9
                  ? `${(Math.abs(Number(totalAmount)) / 1.0e9).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}B`
                  : // Six Zeroes for Millions
                  Math.abs(Number(totalAmount)) >= 1.0e6
                  ? `${(Math.abs(Number(totalAmount)) / 1.0e6).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}M`
                  : Math.abs(Number(totalAmount)).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row">
            {/* List */}
            <Grid
              item
              xs={12}
              md={5}
              lg={showDetailsBox ? 5 : 4}
              xl={showDetailsBox ? 4 : 3}
              className={classes.itemsList}
            >
              {pieChartList.map((item: any) => {
                return (
                  <Grid
                    container
                    direction="row"
                    key={item.name}
                    className={
                      selectedRevenue === item.name
                        ? `${classes.selectedItem} ${classes.item}`
                        : classes.item
                    }
                    onClick={() => showRevenue(item)}
                  >
                    <Grid container direction="row" item xs={7}>
                      <div
                        className="colorPicker"
                        style={{
                          width: "15px",
                          height: "15px",
                          margin: "0 10px 14px 0px",
                          backgroundColor: colors[pieChartList.indexOf(item)],
                        }}
                      ></div>
                      <Box className={classes.label}>{item.name}</Box>
                    </Grid>
                    <Grid item xs={5} className={classes.labelNumber}>
                      {item.amount.toLocaleString(undefined, { maximumFractionDigits: 2 })}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            {/* Pie Chart */}
            <Grid item xs={12} md={6} lg={6} xl={6} className={classes.pieChartDiv}>
              <Box maxWidth={350} maxHeight={350}>
                <Pie data={data} options={pieChartOptions} />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* Bar Chart No Data */}
        <Grid
          item
          xs={12}
          lg={5}
          style={{
            display: showDetailsBox && showNoBarDataFound ? "block" : "none",
            justifyContent: "space-around",
            fontSize: "14px",
          }}
        >
          <Box
            className={classes.outer}
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "space-around",
              fontSize: "14px",
            }}
            sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
          >
            No data found.
          </Box>
        </Grid>
        {/* Bar Chart */}
        <Grid
          item
          xs={12}
          lg={5}
          style={{
            display: showDetailsBox && !showNoBarDataFound ? "block" : "none",
          }}
        >
          <Box
            className={classes.outer}
            style={{ height: "100%" }}
            sx={{ marginLeft: { xs: "0", lg: "10px" }, marginTop: { xs: "10px", lg: "0" } }}
          >
            <Grid item container direction="row">
              <Grid item xs={9} container direction="row">
                <Typography className={classes.headingText}>{barChartHeading}: </Typography>
                <Typography className={classes.unit}>PKR</Typography>
                <Typography className={classes.headingAmount}>
                  {barChartHeadingValue.toLocaleString(undefined, { maximumFractionDigits: 2 })}{" "}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                {/* <Box
                  style={{
                    fontSize: "15px",
                    cursor: "pointer",
                    color: "#488cfb",
                    textDecoration: "underline",
                    paddingTop: "7px",
                  }}
                  onClick={toggleDialog}
                >
                  Comparison
                </Box> */}
              </Grid>
            </Grid>
            <Grid container direction="row">
              {barChartList.map((item: any) => {
                return (
                  <Grid
                    container
                    direction="row"
                    item
                    xs={6}
                    key={item.name}
                    className={classes.barChartItem}
                  >
                    <Grid item xs={7}>
                      {item.name ? item.name : "N/A"}:
                    </Grid>
                    <Grid item xs={5} className={classes.barChartItemAmount}>
                      {item.amount}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
            <Bar options={barChartOptions} data={barChartData} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
